<script setup lang="ts">
// Use centralized tracking composable
const { trackPageView } = useTracking();

// Track pageview events on SPA navigation
useScriptEventPage(({ title, path }) => {
    void trackPageView(title, path);
});
</script>
<template>
    <div
        class="bg-gradient-to-br from-blue-500 to-blue-900 bg-no-repeat min-h-screen flex flex-col"
        style="background-size: 100% 200px"
    >
        <MainMenu />
        <div class="container mx-auto mt-4 main-container">
            <slot />
        </div>
        <Footer />
    </div>
</template>
